function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import Select from 'react-select';
import { frequency, times, timeZones, timeZone } from "../../data/schedule";
import { MDCTextInput } from "../../../jsx/components/mdc-components";
import DataTypes from "./data-types";
import { downloadTemplate, PRODUCT_COLUMNS, PRODUCT_SPEC_URL } from "../../functions/csv-templates";
export default class extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onFrequencyChange", data => {
      this.setState({
        frequency: data
      });
    });
    _defineProperty(this, "onTimeChange", data => {
      this.setState({
        hour: data
      });
    });
    _defineProperty(this, "onTimeZoneChange", data => {
      this.setState({
        timezone: data
      });
    });
    _defineProperty(this, "onUrlChange", event => {
      var target = event.target;
      this.setState({
        url: target.value
      });
    });
    _defineProperty(this, "onUsernameChange", event => {
      var target = event.target;
      this.setState({
        username: target.value
      });
    });
    _defineProperty(this, "onPasswordChange", event => {
      var target = event.target;
      this.setState({
        password: target.value
      });
    });
    _defineProperty(this, "onSaveFetch", () => {
      var model = this.model;
      this.props.onSaveFetch(model);
    });
    _defineProperty(this, "onDeleteFetch", () => {
      this.props.onDeleteFetch();
    });
    _defineProperty(this, "onDownloadTemplate", event => {
      downloadTemplate("product-template.csv", PRODUCT_COLUMNS);
    });
    _defineProperty(this, "onDownloadSpec", event => {
      window.open(PRODUCT_SPEC_URL, "_blank", "noopener");
    });
    this.state = this.initState();
  }
  initState() {
    if (this.props.data) {
      return this.stateFromData;
    } else return {
      frequency: null,
      hour: null,
      timezone: null,
      url: '',
      status: '',
      username: '',
      password: ''
    };
  }
  get stateFromData() {
    var data = this.props.data;
    var settings = data.settings;
    settings = JSON.parse(settings);
    var state = {
      frequency: null,
      hour: null,
      timezone: null,
      url: settings.Url,
      status: data.status,
      username: settings.Username,
      password: settings.Password
    };
    frequency.forEach(obj => {
      if (obj.value === data.frequency) {
        state.frequency = obj;
      }
    });
    times.forEach(obj => {
      if (obj.value === data.hour) {
        state.hour = obj;
      }
    });
    state.timezone = timeZone(data.timezone);
    return state;
  }
  componentDidMount() {}
  get model() {
    var state = this.state;
    console.log(state);
    var frequency = null;
    var hour = 0;
    var timezone = null;
    var url = state.url;
    var username = state.username;
    var password = state.password;
    var status = state.status;
    if (state.frequency) {
      frequency = state.frequency.value;
    }
    if (state.hour) {
      hour = state.hour.value;
    }
    if (state.timezone) {
      timezone = state.timezone.value;
    }
    var model = {
      frequency: frequency,
      hour: hour,
      status: status,
      timezone: timezone,
      url: url,
      username: username,
      password: password
    };
    return model;
  }
  render() {
    var data = this.props.data;
    var showDeleteButton = this.props.showDeleteButton;
    var header = 'Create a Fetch Schedule';
    if (data) {
      header = 'Update Your Fetch Schedule';
    }
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "medium"
    }, header), /*#__PURE__*/React.createElement("div", {
      className: "size-14"
    }, "Data types you can use:"), /*#__PURE__*/React.createElement(DataTypes, null), /*#__PURE__*/React.createElement("a", {
      className: "size-14-hover",
      onClick: this.onDownloadTemplate
    }, "Download Template"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
      className: "size-14-hover",
      onClick: this.onDownloadSpec
    }, "Download Product Spec"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: "subtext"
    }, "Fetch frequency"), /*#__PURE__*/React.createElement("div", {
      className: "flex-mobile"
    }, /*#__PURE__*/React.createElement(Select, {
      value: this.state.frequency,
      options: frequency,
      onChange: this.onFrequencyChange,
      className: "multi-select-width-2"
    }), /*#__PURE__*/React.createElement("div", {
      className: "info-box"
    }, "Weekly and monthly frequencies will trigger a fetch the first day of the applicable period.")), /*#__PURE__*/React.createElement("div", {
      className: "margin-top"
    }, /*#__PURE__*/React.createElement("div", {
      className: "subtext"
    }, "Fetch time"), /*#__PURE__*/React.createElement(Select, {
      value: this.state.hour,
      options: times,
      onChange: this.onTimeChange,
      className: "multi-select-width-2"
    })), /*#__PURE__*/React.createElement("div", {
      className: "margin-top"
    }, /*#__PURE__*/React.createElement("div", {
      className: "subtext"
    }, "Time zone"), /*#__PURE__*/React.createElement(Select, {
      value: this.state.timezone,
      options: timeZones,
      onChange: this.onTimeZoneChange,
      className: "multi-select-width-3"
    })), /*#__PURE__*/React.createElement("div", {
      className: "margin-top"
    }, /*#__PURE__*/React.createElement(MDCTextInput, {
      value: this.state.url,
      onChange: this.onUrlChange,
      label: "File Url",
      cls: "multi-select-width-3"
    }), /*#__PURE__*/React.createElement("div", {
      className: "size-12 subtext"
    }, "(supported protocols: http, https, ftp)")), /*#__PURE__*/React.createElement("div", {
      className: "margin-top two"
    }, /*#__PURE__*/React.createElement("div", {
      className: "size-14 medium"
    }, "If your URL is password protected, provide your login info"), /*#__PURE__*/React.createElement(MDCTextInput, {
      value: this.state.username,
      onChange: this.onUsernameChange,
      label: "Username(optional)",
      cls: "multi-select-width-3"
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(MDCTextInput, {
      value: this.state.password,
      onChange: this.onPasswordChange,
      label: "Password(optional)",
      cls: "multi-select-width-3"
    })), /*#__PURE__*/React.createElement("div", {
      className: "margin-top"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-box"
    }, /*#__PURE__*/React.createElement("button", {
      className: "ui-button primary margin-right",
      onClick: this.onSaveFetch
    }, "Save"), showDeleteButton && /*#__PURE__*/React.createElement("button", {
      className: "ui-button margin-right",
      onClick: this.onDeleteFetch,
      style: {
        background: 'transparent',
        color: '#dc2626',
        border: '1px solid #dc2626'
      }
    }, "Delete"), /*#__PURE__*/React.createElement("button", {
      className: "ui-button secondary small icon span-margin",
      onClick: this.props.onFetchBack
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "arrow_left"), "Back"))));
  }
}